(function ($, Global) {
    function BannerOfferPmeComponent() {
        // Déclaration class objet
    }

	BannerOfferPmeComponent.prototype.initEvents = function () {
		this.publishers();
	}

    BannerOfferPmeComponent.prototype.publishers = function () {  
        var divContainer = $('.banner-offer-header');
        $('.banner-offer-header .icon').on('click', function () {
            if (divContainer.hasClass('open')) {
                divContainer.removeClass('open');
                Global.Cookie.create('BAN_OFR_OUVERT', 'false', 365);
            }
            else {
                divContainer.addClass('open')
                Global.Cookie.create('BAN_OFR_OUVERT', 'true', 365);
            }
        })
	}

    Global.BannerOfferPmeComponent = BannerOfferPmeComponent;
}(jQuery, window));